import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as ajax from './ajax';
import cabinetConstants from '../constants/cabinetConstants';
import logger from '../utils/logger';
import optimizeCabinetIndexQueryFilters from '../utils/optimizeCabinetIndexQueryFilters';

/**
 * Fetches the filtered form total (GET /forms?asCount=true) after a cabinet list success.
 * Dispatches cabinetConstants.INDEX_COUNT_SUCCESS with the total for filters.cabinetIdentifier.
 */
const fetchCabinetIndexCount = indexQuery => async dispatch => {
  var _indexQuery$filters, _indexQuery$filters2;
  if (!(indexQuery !== null && indexQuery !== void 0 && (_indexQuery$filters = indexQuery.filters) !== null && _indexQuery$filters !== void 0 && (_indexQuery$filters = _indexQuery$filters.formTypeIdentifiers) !== null && _indexQuery$filters !== void 0 && _indexQuery$filters.length)) {
    return null;
  }
  if (!(indexQuery !== null && indexQuery !== void 0 && (_indexQuery$filters2 = indexQuery.filters) !== null && _indexQuery$filters2 !== void 0 && _indexQuery$filters2.cabinetIdentifier)) {
    return null;
  }
  const query = JSON.parse(JSON.stringify(indexQuery));
  if (query.pendingFilters) {
    query.filters = _objectSpread(_objectSpread({}, query.filters), query.pendingFilters);
  }
  const cleanedQuery = _objectSpread(_objectSpread({}, query), {}, {
    asCount: true,
    filters: optimizeCabinetIndexQueryFilters(query.filters)
  });
  delete cleanedQuery.expiration;
  delete cleanedQuery.initialized;
  delete cleanedQuery.pendingFilters;
  try {
    const response = await ajax.get('/forms', cleanedQuery);
    const _ref = response.data || {},
      totalCount = _ref.totalCount;
    if (totalCount == null) {
      return null;
    }
    return dispatch({
      type: cabinetConstants.INDEX_COUNT_SUCCESS,
      payload: {
        cabinetIdentifier: indexQuery.filters.cabinetIdentifier,
        totalCount
      }
    });
  } catch (e) {
    logger("cabinet index count failed: ".concat(e && e.message ? e.message : e));
    return null;
  }
};
export default fetchCabinetIndexCount;